<input type="text" [(ngModel)]="input" id="sumUpInput" class="sumup-input" />
